module.exports = __webpack_public_path__ + "img/workorderlist1.0b872a46.png";